import React, { ImgHTMLAttributes, useState } from 'react';

interface IProps extends ImgHTMLAttributes<HTMLImageElement> {
  srcAppendix?: string;
  catchError?: boolean;
}

export default function Image({
  src: srcSource,
  srcAppendix,
  catchError = true,
  alt,
  ...rest
}: IProps) {
  const [src, setSrc] = useState(`${srcSource}${srcAppendix || ''}`);
  const [errored, setErrored] = useState(false);

  return (
    <img
      src={src}
      alt={alt}
      onError={() => {
        if (!errored && catchError) {
          setSrc(`/no-image.png${srcAppendix || ''}`);
          setErrored(true);
        }
      }}
      {...rest}
    />
  );
}
